import { gray3, gray7 } from "assets/styleUtils";
import React from "react";

export default function DotText({
  text,
  numbering,
  circleNumber = false,
  size = "14px",
  lineHeight = "22px",
  color = gray3,
  weight = "400",
  style,
}: {
  text: string | JSX.Element;
  numbering?: string;
  circleNumber?: boolean;
  size?: string;
  lineHeight?: string;
  weight?: "normal" | "bold" | "100" | "300" | "400" | "500" | "700" | "900";
  color?: string;
  style?: React.CSSProperties;
}) {
  const circleSize = `calc(${lineHeight} - 6px)`; // 계산식을 CSS calc()로 변환
  return (
    <div style={{ display: "flex", padding: "1px 3px" }}>
      {circleNumber ? (
        <div
          style={{
            backgroundColor: gray7,
            marginRight: "2px",
            width: circleSize,
            height: circleSize,
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "80%",
              lineHeight: circleSize,
              marginTop: "2px",
            }}
          >
            {numbering ?? "\u2022"}
          </div>
        </div>
      ) : (
        <div
          style={{
            lineHeight: "20px",
            padding: "0 5px",
            color: gray3,
            fontSize: size,
          }}
        >
          {numbering ?? "\u2022"}
        </div>
      )}
      {typeof text === "string" ? (
        <div
          style={{
            flexWrap: "nowrap",
            color: gray3,
            marginBottom: "2px",
            fontSize: size,
            lineHeight,
            fontWeight: weight,
          }}
        >
          {text}
        </div>
      ) : (
        text
      )}
    </div>
  );
}
